import React from 'react';

export default function ProfileDropdown({ onLogout }) {
  const name = localStorage.getItem('name') || 'User';
  const email = localStorage.getItem('email') || 'user@example.com';

  return (
    <div className="relative group inline-block">
      <img
        src="/images/default_avatar.png"
        alt="Profile"
        className="block h-10 w-10 rounded-full object-cover align-middle"
      />
      {/*
        pt-2 bridges avatar → menu so group-hover stays active while moving to Logout.
        pointer-events-none until open so page content below (author home) is not blocked.
      */}
      <div className="absolute right-0 top-full z-50 pt-2 opacity-0 pointer-events-none transition-opacity duration-200 group-hover:opacity-100 group-hover:pointer-events-auto">
        <div className="w-48 overflow-hidden rounded-lg border bg-white shadow-lg">
          <div className="border-b p-4 text-sm">
            <p className="truncate font-medium">{name}</p>
            <p className="mt-1 truncate text-xs text-gray-500">{email}</p>
          </div>
          <button
            type="button"
            onClick={onLogout}
            className="block w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-gray-100"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}
